module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/texas-monthly-2x.791624c3bb47cd006e6698a654d8711b.png";